<div class="multiple-items" style="margin-top:30vh;">
    <div>
        <img src="../.././../assets/img/snow-covered-mountain-during-sunrise-header.jpg">
    </div>
    <div>
        <img src="../.././../assets/img/Wheel.png">
    </div>
    <div>

        <img src="../.././../assets/img/snow-covered-mountain-during-sunrise-header.jpg">

    </div>
    <div>

        <img src="../.././../assets/img/snow-covered-mountain-during-sunrise-header.jpg">

    </div>
    <div>

        <img src="../.././../assets/img/snow-covered-mountain-during-sunrise-header.jpg">

    </div>

</div>



<link rel="stylesheet" type="text/css" href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css" />
<script type="text/javascript" src="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"></script>